import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/aditya-singh-97396a21a/'
      className='link footer__link'
    >
      Created By Aditya Singh
    </a>
  </footer>
)

export default Footer
